<app-header-user></app-header-user>
<!-- Page title -->

<div class="container pt-4 pb-5">
    <div class="row">
        <!-- Info box sus -->
        <div class="col-12 mb-4">
            <h2>Bilete de trimitere emise</h2>
            <p class="mb-0 text-muted">
                Vizualizați biletele de trimitere interne și externe
                emise pe numele dumneavoastră, cu informații despre
                medic, specialitate și dată.
            </p>
            <button
                class="btn btn-success btn-rounded my-2"
                (click)="addTicket()"
            >
                <i class="bx bx-plus me-1"></i> Adaugă bilet de trimitere
            </button>
        </div>
    </div>
    <!-- Tabs interne / externe -->
    <ngx-tabset class="tableCard-tabs">
        <!-- Interne -->
        <ngx-tab tabTitle="Bilete de trimitere interne">
            <div class="card dashboard-card tickets-card">
                <div class="card-body p-0">
                    <div *ngIf="loading" class="text-center py-4">
                        <div
                            class="spinner-border spinner-sm text-success"
                        ></div>
                    </div>

                    <div
                        *ngIf="!loading"
                        class="table-responsive tickets-table-wrapper"
                    >
                        <table class="table table-sm mb-0 tickets-table">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Data</th>
                                    <th>Tip</th>
                                    <th>Specialitate</th>
                                    <th>Medic</th>
                                    <th>Serie / Număr</th>
                                    <!-- <th>Cost</th> -->
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    *ngIf="
                                        !internalTickets ||
                                        internalTickets.length === 0
                                    "
                                >
                                    <td
                                        colspan="7"
                                        class="text-center text-muted py-3"
                                    >
                                        {{ messageInternal }}
                                    </td>
                                </tr>
                                <tr
                                    *ngFor="
                                        let ticket of internalTickets;
                                        let i = index
                                    "
                                >
                                    <td>{{ i + 1 }}</td>
                                    <td>
                                        {{ ticket.date | date: "dd.MM.yyyy" }}
                                    </td>
                                    <td>
                                        <span *ngIf="ticket.type">
                                            {{ ticket.type.labels[0].label }}
                                        </span>
                                    </td>
                                    <td>
                                        <span *ngIf="ticket.specialtyCode">
                                            {{
                                                ticket.specialtyName
                                            }}
                                        </span>
                                    </td>
                                    <td>{{ ticket.doctorName }}</td>
                                    <td>
                                        {{ ticket.batch }} /     {{ ticket.number }}
                                    </td>
                                    <!-- <td>0</td> -->
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </ngx-tab>

        <!-- Externe -->
        <ngx-tab tabTitle="Bilete de trimitere externe">
            <div class="card dashboard-card tickets-card">
                <div class="card-body p-0">
                    <div *ngIf="loading" class="text-center py-4">
                        <div
                            class="spinner-border spinner-sm text-secondary"
                        ></div>
                    </div>

                    <div
                        *ngIf="!loading"
                        class="table-responsive tickets-table-wrapper"
                    >
                        <table class="table table-sm mb-0 tickets-table">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Data</th>
                                    <th>Tip</th>
                                    <th>Serie / Număr</th>
                                    <th>Casa de asigurări</th>
                                    <th>Specialitate</th>
                                    <th>Doctor</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    *ngIf="
                                        !externalTickets ||
                                        externalTickets.length === 0
                                    "
                                >
                                    <td
                                        colspan="7"
                                        class="text-center text-muted py-3"
                                    >
                                        {{ messageExternal }}
                                    </td>
                                </tr>
                                <tr
                                    *ngFor="
                                        let ticket of externalTickets;
                                        let i = index
                                    "
                                >
                                    <td>{{ i + 1 }}</td>
                                    <td>
                                        {{ ticket.createdDate | date: "dd.MM.yyyy" }}
                                    </td>
                                    <td>{{ ticket.diagnosticType }}</td>
                                    <td>
                                        {{ ticket.batch }} / {{ ticket.number }}
                                    </td>
                                    <td>
                                        {{ ticket.healthOrganisation }}
                                    </td>
                                    <td>{{ ticket.senderSpecialization }}</td>
                                    <td>{{ ticket.senderDoctor }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </ngx-tab>
    </ngx-tabset>
</div>
